import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import CustomFieldsComponent from './CustomFieldsComponent';

const tabItems = ['piers', 'structures', 'module'];

const TabComponent = ({
  customFields,
  setCustomFields,
  checkpoints,
  setCheckpoints,
  isEdit,
  value,
  setValue,
  loading,
  tabLoader,
  selectedPier,
  selectedTt,
  active,
  errors,
  setErrors,
  currentProject
}) => {
  const handleChange = (_, newValue) => setValue(newValue);

  const currentView = tabItems[value];

  return (
    <Box sx={{ bgcolor: isEdit ? '#f5f5f5b8' : '#f3f4f6', p: 2, borderRadius: 2 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        TabIndicatorProps={{ style: { backgroundColor: '#f16253' } }}
        sx={{
          flex: 1,
          bgcolor: '#fee2e2',
          borderRadius: 1,
          '& .MuiTab-root': {
            color: '#333',
            fontWeight: 600,
          },
          '& .Mui-selected': {
            bgcolor: 'white',
            color: '#f16253',
            borderRadius: 1,
          },
        }}
      >
        {tabItems.map((label) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>

      <Box mt={1}>
        <CustomFieldsComponent
          view={currentView}
          customFields={customFields}
          setCustomFields={setCustomFields}
          checkpoints={checkpoints}
          setCheckpoints={setCheckpoints}
          isEdit={isEdit}
          loading={loading}
          tabLoader={tabLoader}
          selectedPier={selectedPier}
          selectedTt={selectedTt}
          active={active}
          errors={errors}
          setErrors={setErrors}
          currentProject={currentProject}
        />
      </Box>
    </Box>
  );
};

export default TabComponent;
